import { render, staticRenderFns } from "./DoughnutOrders.vue?vue&type=template&id=2d62a94e&scoped=true&"
import script from "./DoughnutOrders.vue?vue&type=script&lang=js&"
export * from "./DoughnutOrders.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutOrders.vue?vue&type=style&index=0&id=2d62a94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62a94e",
  null
  
)

export default component.exports